'use client';

import { useMemo } from 'react';

import { useBoolean, useWindowSize } from 'codekit';
import { motion } from 'framer-motion';

import { Icon } from 'components/Icon';
import { app } from 'config/app';
import Button from 'layouts/institucional/Button';
import { cn } from 'utils/cn';
import { getAnimationProps } from 'utils/motion/getAnimationProps';
import Section from '..';
import Spotlight from './Spotlight';

import styles from './styles.module.css';

const desktopTitle = 'Melhore & automatize <br/> suas mensagens de commit';
const mobileTitle = 'Dê super <br/>poderes para <br/>os commits';

function SectionHero() {
	// Hooks
	const size = useWindowSize();

	// Boolean hooks
	const isVisibleSpotlight = useBoolean(false);

	// Memo vars
	const title = useMemo(() => {
		const title = size.isMobile ? mobileTitle : desktopTitle;

		return title.split(' ');
	}, [size.isMobile]);

	return (
		<Section
			className={styles.container}
			containerClassName={styles.section}
			paddingVertical="104px"
		>
			{isVisibleSpotlight.value && <Spotlight />}

			<div className={styles.text}>
				<motion.div
					className={cn(styles.tag)}
					onClick={() =>
						document
							.querySelector('#video')
							?.scrollIntoView({ behavior: 'smooth' })
					}
					{...getAnimationProps('blur_in', title.length + 6)}
				>
					<Icon name="Play" fill="var(--color-primary)" />
					Ver demostração
					<div className={styles.shine}>
						<div className={styles.line} />
						<div className={styles.star} />
					</div>
				</motion.div>

				<h1>
					{title.map((part, index, array) => (
						<motion.span
							key={part}
							className={styles.blur_in}
							dangerouslySetInnerHTML={{ __html: part + ' ' }}
							{...getAnimationProps('blur_in', index)}
							onAnimationComplete={() => {
								if (index === array.length - 1)
									isVisibleSpotlight.setTrue();
							}}
						/>
					))}
				</h1>

				<motion.p {...getAnimationProps('blur_in', title.length + 1)}>
					Com o {app.name} você pode focar no que realmente importa,
					sem se preocupar em gastar tempo e esforço para escrever
					detalhadas e padronizadas mensagens de commit.
				</motion.p>

				<motion.div
					className={styles.buttons}
					{...getAnimationProps('blur_in', title.length + 3)}
				>
					<Button
						linkTo="auth.register"
						variant="default"
						linkProps={{
							'aria-label': 'Criar conta e testar grátis',
						}}
					>
						Criar conta e testar grátis{' '}
						<Icon name="MoveRight" className="move-right" />
					</Button>

					<a href="#features">
						<Button variant="text">
							Saiba mais <Icon name="CornerRightDown" />
						</Button>
					</a>
				</motion.div>
			</div>
		</Section>
	);
}

export default SectionHero;
